import * as React from 'react';

import Icon from '../../icons/Icon';

interface Props {
  size?: number;
  color?: string;
}

const SettingsIcon: React.FunctionComponent<Props> = props => {
  return <Icon name={'settingsViewer'} {...props} />;
};

export default React.memo(SettingsIcon);
